"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const LayoutShell = /*#__PURE__*/_react.default.memo(({
  sideBar,
  sideBarWidth,
  topBar,
  children,
  footer,
  withTabs,
  onSkipToMainContent,
  onSkipToNav
}) => {
  const SkipToMainContentLink = (0, _jsxRuntime.jsx)("button", {
    css: theme => (0, _styles.skipLinkStyle)(theme),
    onClick: onSkipToMainContent,
    role: "link",
    "data-tracking-name": "Felles",
    "data-tracking-event": "Klikk: G\xE5 til hovedinnhold",
    children: "G\xE5 til hovedinnhold"
  });
  const SkipToNavLink = (0, _jsxRuntime.jsx)("button", {
    css: theme => (0, _styles.skipLinkStyle)(theme),
    role: "link",
    onClick: onSkipToNav,
    "data-tracking-name": "Felles",
    "data-tracking-event": "Klikk: G\xE5 til undermeny",
    children: "G\xE5 til undermeny"
  });
  const hasSideBar = Boolean(sideBar && sideBarWidth);
  const Tag = Boolean(withTabs || hasSideBar) ? _styles.WrapperTag : _react.Fragment;
  return (0, _jsxRuntime.jsxs)(Tag, {
    sideBarWidth: sideBarWidth ? sideBarWidth : undefined,
    children: [onSkipToNav && SkipToNavLink, onSkipToMainContent && SkipToMainContentLink, hasSideBar ? (0, _jsxRuntime.jsx)(_styles.SideBar, {
      sideBarWidth: sideBarWidth,
      children: sideBar
    }) : (0, _jsxRuntime.jsx)(_react.Fragment, {}), (0, _jsxRuntime.jsxs)(_styles.MainContent, {
      sideBarWidth: sideBarWidth,
      children: [topBar, (0, _jsxRuntime.jsx)(_styles.Content, {
        children: children
      })]
    }), hasSideBar ? (0, _jsxRuntime.jsx)(_styles.FooterWrapper, {
      children: footer
    }) : footer]
  });
});
var _default = exports.default = LayoutShell;